import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import React from 'react'
import { UpsertAction } from '../Enums'

export interface WeightSelectControlProps {
    key?: string;
    value: any;
    mode: UpsertAction;
    width?: any;
    onChangeHandler: (event: SelectChangeEvent<any>) => void;
}

const WeightSelectControl = ({key, value, mode, width, onChangeHandler}: WeightSelectControlProps) => {

    const selectionValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    return (
        <Select
            key={key ?? ''}
            disabled={mode === UpsertAction.View}
            size="small"
            value={value ?? ''}
            onChange={onChangeHandler}>
            {
                selectionValues.map((level) =>
                    <MenuItem key={level} value={level}>{level}</MenuItem>)
            }
        </Select>
    )
}

export default WeightSelectControl